import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]
  static values = {
    frameId: { type: String, default: "herb-results" },
    minLength: { type: Number, default: 2 }
  }

  connect() {
    this._timer = null
    this._frameRenderHandler = (event) => {
      if (event.target.id !== this.frameIdValue) return
      // URL is already updated by Turbo before turbo:frame-render fires
      if (!new URLSearchParams(window.location.search).has("query")) {
        this.inputTarget.value = ""
      }
    }
    document.addEventListener("turbo:frame-render", this._frameRenderHandler)
  }

  disconnect() {
    clearTimeout(this._timer)
    document.removeEventListener("turbo:frame-render", this._frameRenderHandler)
  }

  onInput(event) {
    clearTimeout(this._timer)
    const val = event.target.value.trim()
    // Ignore short, noisy queries; a cleared field (length 0) still submits to
    // reset the results.
    if (val.length > 0 && val.length < this.minLengthValue) return
    // delay=0 on clear so results reset immediately without visual lag
    const delay = val.length === 0 ? 0 : 300
    this._timer = setTimeout(() => {
      this.element.requestSubmit()
    }, delay)
  }
}
